import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import { IoMicOutline, IoStopOutline, IoChevronDownOutline } from 'react-icons/io5';
import { useDarkMode } from '../context/DarkModeContext';
import { createLogger } from '../utils/logger';

const logger = createLogger({ module: 'VoiceRecordingControl' });

// Lazy load the voice recording hook
const VoiceRecordingFeature = lazy(() => import('./VoiceRecordingFeature'));

interface VoiceRecordingControlProps {
  onTranscriptReceived?: (text: string) => void;
  className?: string;
}

export const VoiceRecordingControl: React.FC<VoiceRecordingControlProps> = ({
  onTranscriptReceived,
  className = ''
}) => {
  const { darkMode } = useDarkMode();
  const [isVoiceFeatureLoaded, setIsVoiceFeatureLoaded] = useState(false);

  const handleInitialClick = () => {
    setIsVoiceFeatureLoaded(true);
  };

  if (!isVoiceFeatureLoaded) {
    return (
      <button
        onClick={handleInitialClick}
        className={`
          inline-flex
          items-center
          justify-center
          w-7
          h-7
          rounded-full
          transition-all
          duration-200
          ${darkMode 
            ? 'bg-gray-800 text-white hover:bg-gray-700' 
            : 'bg-white text-gray-800 hover:bg-gray-50'
          }
          hover:ring-1
          hover:ring-blue-500
          cursor-pointer
        `}
        aria-label="Start Dictation"
      >
        <IoMicOutline className="w-4 h-4 text-blue-500" />
      </button>
    );
  }

  return (
    <div className={className}>
      <Suspense fallback={
        <div className="flex items-center justify-center p-4">
          <div className="animate-spin rounded-full h-5 w-5 border-2 border-blue-500 border-t-transparent"></div>
        </div>
      }>
        <VoiceRecordingFeature
          onTranscriptReceived={onTranscriptReceived}
        />
      </Suspense>
    </div>
  );
}; 